/* eslint-disable react/display-name */
/* eslint-disable react/no-find-dom-node */
import React              from 'react';
import ReactDOM           from 'react-dom';
import { Link }           from 'react-router-dom';
import moment             from 'moment';

import Button             from '~/components/Button';

import Badge              from '@material-ui/core/Badge';
import SaveAlt            from '@material-ui/icons/SaveAlt';
import Mail               from '@material-ui/icons/Mail';
import Print              from '@material-ui/icons/Print';
import FilterList         from '@material-ui/icons/FilterList';
import Edit               from '@material-ui/icons/Edit';
import Delete             from '@material-ui/icons/Delete';
import RemoveRedEye       from '@material-ui/icons/RemoveRedEye';
import Send               from '@material-ui/icons/Send';
import LocalHospital      from '@material-ui/icons/LocalHospital';
import Assignment         from '@material-ui/icons/Assignment';

import ViewColumn         from '../components/ViewColumn';
import SearchBar          from '../components/SearchBar';

export default function({
  t,
  actionClass,
  listEl,
  routeToNew,
  routeToEdit,
  routeToShow,
  routeToExams,
  deleteAction,
  filterSize,
  setOpenFilter,
  pushModalAction,
  cancelModalAction,
  modalEditAction,
  modalShowAction,
  modalNewAction,
  modalMedicAction,
  changeQS,
  eraseQS,
  history,
  queryString,
  onExport,
}) {
  return {
    export: {
      icon: () => <SaveAlt />,
      tooltip: t('materialTable.toolbar.exportName'),
      isFreeAction: true,
      onClick: onExport,
    },
    print: {
      icon: () => <Print />,
      tooltip: t('materialTable.header.print'),
      isFreeAction: true,
      onClick: () => {
        const elDom = ReactDOM.findDOMNode(listEl.current);

        elDom.classList.add('printable');
        window.print();
        elDom.classList.remove('printable');
      },
    },
    showHide: {
      icon: () => <ViewColumn />,
      iconProps: {
        'aria-controls': 'long-menu',
        'aria-haspopup': 'true',
        'variant': 'contained',
      },
      tooltip: t('materialTable.header.showHideColumn'),
      isFreeAction: true,
      noButton: true,
    },
    filter: {
      filterSize,
      icon: () => {
        if (filterSize > 0)
          return (
            <Badge color="primary" badgeContent={filterSize}>
              <FilterList />
            </Badge>
          );

        return <FilterList />;
      },

      tooltip: t('materialTable.header.filter'),
      isFreeAction: true,
      onClick: () => setOpenFilter(true),
    },
    search: {
      icon: () => {
          return (<SearchBar onSearch={changeQS} queryString={queryString} history={history} eraseQS={eraseQS} />);
      },

      onClick: () => {
        //onClick is required
      },
      isFreeAction: true,
      noButton: true,
    },
    new: {
      icon: () => (
        modalNewAction ?
        <Button onClick={modalNewAction} color="success">
          {t('materialTable.toolbar.newTitle')}
        </Button>
        :
        <Link to={routeToNew.spec} style={{ textDecoration: 'inherit' }}>
          <Button color="success">
            {t('materialTable.toolbar.newTitle')}
          </Button>
        </Link>
      ),
      onClick: () => {
        //onClick is required
      },
      isFreeAction: true,
      noButton: true,
    },
    edit: ({ id }) => ({
      icon: () => (
        <Link to={routeToEdit.reverse({ id })}>
          <Edit className={actionClass.edit} />
        </Link>
      ),
      noButton: true,
    }),
    del: ({ id, name, title }) => ({
      icon: () => (
        <Delete
          className={actionClass.del}
          onClick={() => deleteAction(id, name, title)}
        />
      ),
      noButton: true,
    }),
    show: ({ id }) => ({
      icon: () => (
        <Link to={routeToShow.reverse({ id })}>
          <RemoveRedEye className={actionClass.show} />
        </Link>
      ),
      noButton: true,
    }),
    exams: ({ id }) => ({
      icon: () => (
        <Link to={routeToExams.reverse({ id })}>
          <Assignment className={actionClass.exams} />
        </Link>
      ),
      noButton: true,
    }),
    modalCancel: ({ id, name }) => ({
      icon: () => (
        <Mail
          className={actionClass.del}
          onClick={() => cancelModalAction(id, name)}
        />
      ),
      noButton: true,
    }),
    modalPush: ({ id, name }) => ({
      icon: () => (
        <Send
          className={actionClass.modalPush}
          onClick={() => pushModalAction(id, name)}
        />
      ),
      noButton: true,
    }),
    modalMedic: ({ id, name }) => ({
      icon: () => (
        <LocalHospital
          className={actionClass.modalMedic}
          onClick={() => modalMedicAction(id, name)}
        />
      ),
      noButton: true,
    }),
    modalEdit: ({ id, name, description }) => ({
      icon: () => (
        <Edit
          className={actionClass.modalEdit}
          onClick={() => modalEditAction(id, name, description)}
        />
      ),
      noButton: true,
    }),
    modalShow: ({ id, name, description}) => ({
      icon: () => (
        <RemoveRedEye
          className={actionClass.modalShow}
          onClick={() => modalShowAction(id, name, description)}
        />
      ),
      noButton: true,
    }),
    editPush: ({ id, sendAt }) => ({
      icon: () => (
        <Link to={moment().isAfter(moment(sendAt)) ? routeToShow.reverse({ id }) : routeToEdit.reverse({ id })}>
          <Edit className={actionClass.edit} />
        </Link>
      ),
      noButton: true
    })
  };
}
